import {useGenericFilters} from 'app/hooks';
import {selectNotiflyFilters, setNotificationFilters} from 'app/notifly/slice';
import {removePageParams} from 'app/store/sweet-api/utils';
import {shallowEqual} from 'app/utils/react-utils';
import {useAsyncActions} from 'app/utils/redux';

import {convertNotificationLocationParamsToFetchParams} from './api';

import type {NotificationsFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';
export function useNotificationFilters(
  location: Location<NotificationsFetchParamsType>,
  router: InjectedRouter
) {
  const {filters, params, resetFilters} = useGenericFilters(
    location,
    router,
    selectNotiflyFilters,
    useAsyncActions({
      setNotificationFilters,
    }).setNotificationFilters,
    convertNotificationLocationParamsToFetchParams
  );

  const viewingAll = shallowEqual(
    removePageParams(convertNotificationLocationParamsToFetchParams({} as any)),
    removePageParams(params)
  );

  return {
    filters,
    params,
    viewingAll,
    resetFilters,
  };
}
